/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-param-reassign */
import React, { useState, useRef, useEffect } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { Accordion, Card, Button, Modal } from 'react-bootstrap';
import { cloneDeep } from 'lodash';
import { useDispatch } from 'react-redux';

import { MultiSelect } from 'react-multi-select-component';
import moment from 'moment';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import noImage from '../../../../../assets/images/no-image.png';
import { customStyles, imageUrl } from '../../../../../Components/helper';
import CustomTooltip from '../../../../../Components/Tooltip/CustomTooltip';
import CustomDatePicker from '../../../../../Components/Utility/DatePicker/DatePicker';
import ProductCareImage from './ProductCareImage';
import * as customModuleAction from '../../../../Library/CustomModule/Store/CustomModule.action';
import { useSuggestionProvider } from '../../../Provider/SuggestionProvider';
import ConfirmationPopup from '../../../../../Components/ModalPopup/ConfirmationPopup';

import BomImageDropzone from '../../../../../Components/ImgDropzone/BomImageDropzone';

function CareInstructionTable({
  CareLabelSuggestion,
  selectedType,
  checkAccodionActiveState,
  handleClickToggle,
  productRefBlank,
  ele,
  setCareTabs,
  careTabs,
  comState,
}) {
  const { control, disabledSubmitButton, setValue, careLabelEditMode } = useFormContext(); // retrieve all hook methods
  const dispatch = useDispatch();
  const {
    validateFields,
    ids,
    setIds,
    setActiveTab,
    closeImgDeleteModal,
    deleteImgConfirmed,
    imageRowIndex,
    handleSubmitUpload,
    userState,
    setUserState,
    handleImageDelete,
    handleImageUpload,
  } = useSuggestionProvider();
  const childRef = useRef();
  const [uniqueRow, setUniqueRow] = useState([]);
  const [symbolData, setSymbolData] = useState([]);
  const [selected, setSelected] = useState([]);
  const { t } = useTranslation('common');

  useFieldArray({
    control,
    name: 'symbol',
  });

  useEffect(() => {
    if (productRefBlank) {
      setSymbolData([]);
      setSelected([]);
    }
  }, [productRefBlank]);

  useEffect(() => {
    return () => {
      setIds([]);
      setSelected([]);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const arr = [];
    if (selectedType?.value !== 'new') {
      for (const tab of careTabs) {
        const codeIds = tab?.tabColumns?.find((item) => item?.name === 'Code' && item?.tabId === tab?.tabId);
        if (codeIds) {
          const codeValue = {
            [tab.tabId]: tab?.tabDetails
              ?.filter((prop) => prop?.columnId === codeIds?._id && prop?.tabId === tab?.tabId)
              .map((prop) => ({ label: prop?.value, value: prop?.rowId })),
          };
          arr.push(codeValue);
        }
      }
    }

    setUserState((prevState) => ({
      ...prevState,
      tabCodes: arr,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedType, careTabs]);

  const handleEditRow = (selectOption, tabId) => {
    disabledSubmitButton(false);
    setSelected(selectOption);
    const newIds = selectOption.map((item) => item.value);

    // Update the state with unique IDs only
    setIds((prevState) => ({ ...prevState, [tabId]: newIds }));
  };

  useEffect(() => {
    if (Array.isArray(CareLabelSuggestion) && CareLabelSuggestion.length > 0) setSymbolData(CareLabelSuggestion[0]?.symbol);
  }, [CareLabelSuggestion]);

  // for amendment
  useEffect(() => {
    if (symbolData?.length && Array.isArray(selected) && !careLabelEditMode) {
      const data = [];
      selected.forEach((value, index) => {
        symbolData.forEach(async (item) => {
          if (item._id === value.value) {
            data.splice(index, 0, item);
          }
        });
      });
      setValue('symbol', data);
    }
  }, [selected]); // eslint-disable-line

  const handleAddCareLabel = async () => {
    setActiveTab(ele.tabId);
    if (validateFields(ele?.tabId, 'true')) {
      const tabDetails = [];
      disabledSubmitButton(false);
      const newId = await dispatch(customModuleAction.getNewMongoId());
      const foundTabIndex = careTabs?.findIndex((item) => item?.tabId.toString() === ele?.tabId.toString());
      const lastIndex = careTabs?.[foundTabIndex]?.tabDetails?.length > 0 ? careTabs[foundTabIndex].tabDetails.length - 1 : 0;
      const lastRowIndex = careTabs?.[foundTabIndex]?.tabDetails?.length > 0 ? careTabs?.[foundTabIndex]?.tabDetails[lastIndex].rowIndex : 0;
      if (careTabs[foundTabIndex]?.tabColumns?.length > 0) {
        careTabs[foundTabIndex]?.tabColumns?.forEach((column) => {
          tabDetails?.push({
            tabId: ele?.tabId,
            rowId: newId,
            rowIndex: careTabs?.[foundTabIndex]?.tabDetails?.length > 0 ? lastRowIndex + 1 : 0,
            columnId: column?._id,
            value: null,
            isNew: true,
          });
        });
      }
      const updatedCareLabelList = careTabs?.map((item, index) => {
        if (index === foundTabIndex) {
          return {
            ...item,
            tabDetails: [...item.tabDetails, ...tabDetails], // Push the new tabDetails
          };
        }
        return item;
      });

      // Update the state with the modified CareLabelList
      setCareTabs(updatedCareLabelList);
      setUserState((prevState) => ({
        ...prevState,
        addNewRow: true,
      }));
    }
  };

  const setImage = (image) => {
    let imagePath = '';
    if (image?.includes('images/')) {
      imagePath = `${imageUrl}/${image}`;
    } else if (image) {
      imagePath = `https://${process.env.REACT_APP_BUCKET_NAME}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${image}`;
    } else {
      imagePath = noImage;
    }
    return imagePath;
  };
  const handleChange = (value, rowId, columnId, fromDate) => {
    const copyTabData = cloneDeep(ele?.tabDetails);
    const foundCell = copyTabData?.find((cell) => cell?.rowId === rowId && cell?.columnId === columnId);
    const foundRow = copyTabData?.find((cell) => cell?.rowId === rowId);
    if (!foundCell) {
      copyTabData?.push({ columnId, value, rowId: foundRow.rowId, rowIndex: foundRow.rowIndex, tabId: foundRow.tabId });
    } else {
      copyTabData?.forEach((element) => {
        if (element?.rowId === rowId && element?.columnId === columnId) {
          element.value = value;
          if (fromDate) {
            element.isDate = true;
          }
        }
      });
    }
    const updatedCareLabelList = careTabs.map((item) => {
      if (item?.tabId === ele?.tabId) {
        return {
          ...item,
          tabDetails: copyTabData, // Push the new tabDetails
        };
      }
      return item;
    });
    setCareTabs(updatedCareLabelList);
  };
  const eleRender = (column, value, rowIndex, dataRowIndex, rowId) => {
    switch (column?.columnDetails?.columnType?.key) {
      case 'Image':
        return (
          <ProductCareImage
            dataValue={value}
            handleImageUpload={() => handleImageUpload(rowIndex, column._id, value, dataRowIndex, ele?.tabId)}
            handleImageDelete={() => handleImageDelete(rowIndex, column._id, value, dataRowIndex, ele?.tabId)}
            t={t}
          />
        );
      case 'Dropdown':
        return (
          <div className="common-react-select mb-0">
            <Select
              className="common-select"
              classNamePrefix="common-select"
              options={column?.columnDetails?.options}
              styles={customStyles}
              placeholder={t('CARE_LABELS.TABLE.SYMBOL_TABLE.SELECT_CARE_TYPE')}
              menuPosition="fixed"
              getOptionLabel={(option) => `${option?.name}`}
              getOptionValue={(option) => `${option?.name}`}
              name="careType"
              value={value || null}
              onChange={(selectedOption) => handleChange(selectedOption, rowId, column?._id, false)}
            />
          </div>
        );
      case 'Multi_select_Dropdown': {
        const options = column?.columnDetails?.options?.map((option) => ({
          label: option?.name,
          value: option?.name,
        }));
        return (
          <MultiSelect
            className="product-custom-multiselect common-new-multiselect"
            options={options || []}
            placeholder={t('CARE_LABELS.TABLE.SYMBOL_TABLE.SELECT_CARE_TYPE')}
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.value}
            menuPosition="fixed"
            onChange={(selectedOption) => handleChange(selectedOption, rowId, column?._id, false)}
            value={value || []}
          />
        );
      }
      case 'Status':
        return (
          <div className="background-td-color w-100" style={{ backgroundColor: column?.columnDetails?.status?.colourHexCode }}>
            <span>{column?.columnDetails?.status?.colourName}</span>
          </div>
        );
      case 'Radio_button':
        return (
          <div className="d-flex flex-wrap align-items-center">
            {column?.columnDetails?.options?.map((option, i) => {
              const isChecked = value?.name === option?.name;
              return (
                <p className="custom-radio mb-0  mr-2" key={`${rowId}_${column?._id}`}>
                  <input
                    type="radio"
                    id={`radio_${rowId}_${column?._id}_${i}`}
                    name={`radio_${rowId}_${column?._id}_${i}`}
                    checked={isChecked}
                    onChange={() => handleChange(option, rowId, column?._id, false)}
                  />
                  <label htmlFor={`radio_${rowId}_${column?._id}_${i}`} className="radio f-14 text-black">
                    {option.name}
                  </label>
                </p>
              );
            })}
          </div>
        );
      case 'Date_picker':
        return (
          <CustomDatePicker
            keyProp={`date_${rowIndex}_${column?._id}`}
            dateFormat="dd-MMM-yyyy"
            valueProp={value || null}
            placeholder={t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION.DATE_PLACEHOLDER')}
            onChange={(e) => handleChange(e, rowId, column?._id, true)}
          />
        );
      case 'Textbox':
        return (
          <div className="common-input-control mb-0">
            <input
              type="text"
              maxLength={column?.columnDetails?.characterLimit}
              value={value || ''}
              onChange={(e) => handleChange(e?.target?.value, rowId, column?._id, false)}
              className="form-control text-bordered"
            />
            <span className="character-show">
              {value?.length || 0}/{column?.columnDetails?.characterLimit}
            </span>
          </div>
        );
      default:
        return (
          <div className="common-input-control mb-0">
            <input
              type="text"
              value={value || ''}
              onChange={(e) => handleChange(e?.target?.value, rowId, column?._id, false)}
              className="form-control  text-bordered"
            />
          </div>
        );
    }
  };
  const renderValue = (column, value, rowId, rowIndex, dataRowIndex) => {
    if (
      (selectedType?.value === 'amendment' && column?.name !== 'Code') ||
      userState?.addNewRow ||
      (careLabelEditMode && selectedType?.value === 'new') ||
      (careLabelEditMode && selectedType?.value === 'amendment' && column?.name !== 'Code')
    ) {
      return eleRender(column, value, rowIndex, dataRowIndex, rowId);
    }

    switch (column?.columnDetails?.columnType?.key) {
      case 'Status':
        return (
          <div className="background-td-color w-100" style={{ backgroundColor: column?.columnDetails?.status?.colourHexCode }}>
            <span>{column?.columnDetails?.status?.colourName}</span>
          </div>
        );
      case 'Radio_button':
      case 'Dropdown':
        return value?.name || '';
      case 'Image':
        return <img src={setImage(value?.image) || noImage} alt={column?.name} width="70px" height="70px" />;
      case 'Multi_select_Dropdown':
        return value?.map((val) => val?.label).join(', ') || '';
      case 'Date_picker':
        return (value && moment(value).format('DD-MM-YYYY')) || '';
      default:
        return !value || typeof value === 'object' ? '' : value;
    }
  };
  const handleDeleteTabData = (row, tabId) => {
    const updatedCareLabelList = careTabs.map((item) => {
      if (item?.tabId === tabId) {
        return {
          ...item,
          tabDetails: item?.tabDetails?.filter((detail) => detail?.rowId !== row),
        };
      }
      return item;
    });
    setCareTabs(updatedCareLabelList);
  };

  useEffect(() => {
    if (selectedType?.value === 'new' && !careLabelEditMode) {
      setUniqueRow([...new Set(ele?.tabDetails?.filter((detail) => detail?.rowId && detail.isNew).map((row) => row?.rowId))]);
    } else if (selectedType?.value === 'amendment' && !careLabelEditMode) {
      setUniqueRow([...new Set(ele?.tabDetails?.filter((detail) => ids?.[ele?.tabId]?.includes(detail?.rowId)).map((row) => row?.rowId))]);
    } else {
      setUniqueRow([...new Set(ele?.tabDetails?.filter((detail) => detail?.rowId).map((row) => row?.rowId))]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ids, selectedType, careLabelEditMode, ele?.tabDetails]);
  return (
    <div>
      <Card className="overflow-visible">
        <Card.Header className="overflow-visible">
          <div className="d-flex flex-wrap justify-content-between align-items-center w-100">
            <div className="f-16 font-heavy">{ele?.tabName}</div>
            <div className="break" />
            <div className="d-flex align-items-center justify-content-center code-dropdown w-xs-100 ml-md-auto">
              {selectedType && selectedType.value === 'new' ? (
                !careLabelEditMode && (
                  <CustomTooltip tooltipText={t('COMMON_LABEL.ADD')}>
                    <button
                      type="button"
                      disabled={careLabelEditMode || !comState?.accodionArray?.includes(ele?.tabName)}
                      className="btn add-supp-btn p-0"
                      onClick={() => handleAddCareLabel()}
                      title={t('SYMBOLS_LIST.ADD_NEW')}
                      aria-label="add"
                    >
                      <i className="icon-Add f-20" />
                    </button>
                  </CustomTooltip>
                )
              ) : (
                <div className="w-200 select-min-height">
                  <MultiSelect
                    disabled={careLabelEditMode}
                    options={
                      userState?.tabCodes
                        ?.map((it) => it[ele?.tabId])
                        .filter(Boolean)
                        .flat() || []
                    }
                    value={selected}
                    onChange={(select) => handleEditRow(select, ele?.tabId)}
                    labelledBy={t('SYMBOLS_LIST.SELECT')}
                    className="product-custom-multiselect supp-multiselect w-100  common-new-multiselect"
                  />
                </div>
              )}

              <Accordion.Toggle
                className="btn-toggle"
                as={Button}
                variant="link"
                // eventKey="0"
                eventKey={checkAccodionActiveState(ele?.tabName)}
                onClick={() => handleClickToggle(ele?.tabName)}
              >
                <i className={checkAccodionActiveState(ele?.tabName) ? 'icon-new-down-arrow-icon  down-arrow-data inverse' : 'icon-new-down-arrow-icon'} />
              </Accordion.Toggle>
            </div>
          </div>
        </Card.Header>
        <Accordion.Collapse eventKey={checkAccodionActiveState(ele?.tabName)}>
          <Card.Body>
            <div className="table-responsive">
              <table id="care-user-table" className="table common-custom-table">
                {ele?.tabColumns?.length > 0 && (
                  <thead>
                    <tr>
                      {ele?.tabColumns
                        ?.sort((a, b) => a.sequence - b.sequence) // Sort the columns based on the sequence/order
                        .map((column, columnIndex) => (
                          <th
                            key={column?._id}
                            className={`w-${column?.name === 'Image' ? '100px' : '150px'} ${
                              ele?.tabColumns?.length > 6 && ele.tabDetails?.length > 0 && columnIndex === 0 ? 'first-fix-col' : ''
                            }`}
                          >
                            {column?.name}
                          </th>
                        ))}

                      <th aria-label="action" className={ele?.tabColumns.length > 6 && ele?.tabDetails?.length > 0 ? 'last-fix-col w-50px' : 'w-50px'} />
                    </tr>
                  </thead>
                )}
                <tbody>
                  {ele?.tabDetails?.length > 0 && uniqueRow.length > 0 ? (
                    uniqueRow.map((rowId, rowIndex) => {
                      let rowDetails = ele?.tabDetails?.filter((detail) => detail?.rowId === rowId);
                      if (!careLabelEditMode) {
                        rowDetails = ele?.tabDetails?.filter((detail) =>
                          selectedType?.value === 'new' ? detail?.rowId === rowId && detail?.isNew : detail?.rowId === rowId,
                        );
                      }

                      return (
                        <tr key={rowId}>
                          {ele?.tabColumns?.map((column, columnIndex) => {
                            const data = rowDetails?.find((detail) => detail?.columnId === column?._id);
                            return (
                              <td key={column?._id} className={`${ele?.tabColumns?.length > 6 && columnIndex === 0 ? 'first-fix-col' : ''}`}>
                                {renderValue(column, data?.value, rowId, rowIndex, data?.rowIndex)}
                                {column?.columnDetails?.isRequired && !data?.value && data?.hasError && column?.columnDetails?.columnType?.key !== 'Status' && (
                                  <span className="error-message mt-2">{`${column?.name} ${t(
                                    'USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION.REQUIRED_FIELD',
                                  )}`}</span>
                                )}
                              </td>
                            );
                          })}
                          <td className={ele?.tabColumns?.length > 6 ? 'last-fix-col text-right' : 'text-right'}>
                            <CustomTooltip placement="top" tooltipText={t('PIM_MODULE.TAB.DELETE')}>
                              <button aria-label="delete" type="button" className="btn" onClick={() => handleDeleteTabData(rowId, ele?.tabId)}>
                                <i className="icon-Delete f-20" />
                              </button>
                            </CustomTooltip>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={(ele?.tabColumns?.length || 0) + 1} className="text-center">
                        {t('PRODUCT_LIST.ALL_INFORMATION.NO_DATA_AVAILBLE')}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </Card.Body>
        </Accordion.Collapse>
      </Card>
      {userState?.showImageUpload && ele?.tabDetails?.find((prop) => prop?.rowIndex === imageRowIndex) && (
        <Modal className="common-custom-modal modal-large" size="lg" show={userState?.showImageUpload} backdrop="static">
          <Modal.Header>
            <Modal.Title className="f-24">{t('SYMBOLS_LIST.UPLOAD_IMAGE')}</Modal.Title>
            <span onClick={() => handleSubmitUpload('close', '', ele?.tabId)} className="icon-close cursor-pointer text-dark text-decoration-none" />
          </Modal.Header>

          <Modal.Body className="common-image-upload">
            <BomImageDropzone
              ref={childRef}
              title=""
              onSubmit={() => handleSubmitUpload('', childRef, ele?.tabId)}
              image={setImage(userState?.rowImage?.fullImage)}
              acceptedFileExtenstion=".jpeg,.png,.jpg"
            />
          </Modal.Body>
        </Modal>
      )}
      {userState?.showImgDeleteModal && ele?.tabDetails?.find((prop) => prop?.rowIndex === imageRowIndex) && (
        <ConfirmationPopup
          onOpen={userState?.showImgDeleteModal}
          onConfirm={() => deleteImgConfirmed()}
          title={t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION.IMAGE_DELETE_TITLE')}
          message={t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION.IMAGE_DELETE_MESSAGE')}
          toggle={closeImgDeleteModal}
          showThirdMsg
        />
      )}
    </div>
  );
}

export default CareInstructionTable;
